import { render } from "./RegistrationPaymentSuccessPage.vue?vue&type=template&id=314800bc&scoped=true"
import script from "./RegistrationPaymentSuccessPage.vue?vue&type=script&lang=js"
export * from "./RegistrationPaymentSuccessPage.vue?vue&type=script&lang=js"

import "./RegistrationPaymentSuccessPage.vue?vue&type=style&index=0&id=314800bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314800bc"]])

export default __exports__